// @flow

export default () => {
  const rightTheme = {
    'NativeBase.Button': {
      alignSelf: null
    },
    flex: 1,
    alignSelf: 'center',
    alignItems: 'flex-end'
  };

  return rightTheme;
};
